import { useCallback, useContext, useMemo, useState } from "react";
import BaseLoader from "../../components/ui/BaseLoader";
import { useSelector } from "react-redux";
import { LayoutContext } from "../../context/LayoutContext";
import TaskBoardListingHeader from "./TaskBoardListingHeader";
import TaskBoardListing from "./TaskBoardListing";
import useAuth from "../../hooks/useAuth";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useQueryClient } from "@tanstack/react-query";

const TaskBoard = () => {
  const { auth } = useAuth();
  const { userData } = useCurrentUser();
  const isCompanyOwner = userData?.isCompanyOwner;
  const { isBannerVisible } = useContext(LayoutContext);
  const queryClient = useQueryClient();

  const [isAddEditTaskModal, setIsAddEditTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [tasksList, _setTasksList] = useState([]);

  const taskBoardFilters = useSelector((store) => store.taskBoardFilters.value);

  const queryParams = useMemo(() => {
    return {
      search: taskBoardFilters?.search?.trim() || "",
      taskIds: (taskBoardFilters?.taskIds || []).map((t) => t.value ?? t),
      createdByIds: (taskBoardFilters?.createdByIds || []).map((t) => t.value ?? t),
      priority: taskBoardFilters?.priority?.value || "",
      assignees: (taskBoardFilters?.assignees || []).map((a) => a.value ?? a),
      workOrderIds: taskBoardFilters?.workOrder?.value || undefined,
      teamIds:
        taskBoardFilters?.teamIds && taskBoardFilters.teamIds.length > 0
          ? taskBoardFilters.teamIds.map((t) => (t?.value ? t.value : t))
          : (auth.user?.teams || []).map((team) => team.id),
    };
  }, [taskBoardFilters, auth.user?.teams]);

  const refetchAllTeamTask = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ["tasks"] });
  }, [queryClient]);

  // Kept for backward compat with AddEditTaskModal — also triggers column refetch
  const setTasksList = useCallback(
    (updater) => {
      _setTasksList(updater);
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
    },
    [queryClient],
  );

  return (
    <>
      <BaseLoader isLoading={false} />
      <div
        className={`bg-[#F6F6F6] sm:fixed sticky 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all  ${
          isBannerVisible ? "top-[104px] sm:mt-0 mt-12" : "top-[56px]"
        }`}
      >
        <TaskBoardListingHeader
          isAddEditTaskModal={isAddEditTaskModal}
          setIsAddEditTaskModal={setIsAddEditTaskModal}
          setTasksList={setTasksList}
          refetchAllTeamTask={refetchAllTeamTask}
          setSelectedTask={setSelectedTask}
          selectedTask={selectedTask}
          authUserTeams={auth.user?.teams}
          isCompanyOwner={isCompanyOwner}
          authUser={auth?.user}
        />
        <TaskBoardListing
          isAddEditTaskModal={isAddEditTaskModal}
          setIsAddEditTaskModal={setIsAddEditTaskModal}
          tasksList={tasksList}
          setTasksList={setTasksList}
          refetchAllTeamTask={refetchAllTeamTask}
          setSelectedTask={setSelectedTask}
          taskBoardFilters={taskBoardFilters}
          isCompanyOwner={isCompanyOwner}
          queryParams={queryParams}
        />
      </div>
    </>
  );
};

export default TaskBoard;
